import navbarSearchAndPinList from '@/layouts/components/navbarSearchAndPinList'
import themeConfig from '@/../themeConfig.js'
import { colors } from '@/../themeConfig.js'
import logoImg from '@/assets/images/logo.png'

const state = {
  isSidebarActive: true,
  systems:[],
  detailsSystem: [],
  breakpoint: null,
  sidebarWidth: "default",
  reduceButton: themeConfig.sidebarCollapsed,
  bodyOverlay: false,
  sidebarItemsMin: false,
  theme: themeConfig.theme || 'light',
  navbarSearchAndPinList: navbarSearchAndPinList,
  sidebarLogo: logoImg,
  AppActiveUser: {
    id: 0,
    name: 'Mr Dev',
    about: 'About info here',
    img: 'avatar-s-11.png',
    status: 'online',
  },

  filooServer: process.env.VUE_APP_BASE_URL_BACK,
  filooIuguTest: process.env.VUE_APP_IUGU_TEST === "true",
  googleMapUrl: process.env.VUE_APP_GMAPS_URL,
  googleMapKey: process.env.VUE_APP_GMAPS_KEY,
  themePrimaryColor: colors.primary,

  starredPages: navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  userRole: null,

  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar component
  windowWidth: null,

  // Hash path to update sidebar menu at Main.vue
  hashPath: "",
}

export default state
